// extracted by mini-css-extract-plugin
export default {"root":"ContactForm_root__BsBqm","formLabel":"ContactForm_formLabel__9DPRn","formInput":"ContactForm_formInput__X4py7"};